<template><div><p>Kapitel 5. Veranstaltungen</p>
<p>Dieses Kapitel befasst sich mit dem Modul &quot;Veranstaltungen&quot;.</p>
</div></template>


